import type { TestStateSection, TestState } from '@merels/web/deps/debug/positions/positions'
import { StateCard } from './StateCard'

export interface StateSectionProps {
  section: TestStateSection
  isExpanded: boolean
  selectedStateName: string | null
  showJsonViewer: boolean
  onToggle: () => void
  onStateClick: (state: TestState) => void
}

export function StateSection({
  section,
  isExpanded,
  selectedStateName,
  onToggle,
  onStateClick
}: StateSectionProps) {
  const items = section.positions || section.states || []

  return (
    <div className="border-b">
      {/* Section header */}
      <button
        onClick={onToggle}
        className="w-full p-2 text-left font-semibold text-sm bg-muted-bg/30 hover:bg-muted-bg/50 flex items-center justify-between"
        type="button"
      >
        <span>{section.title}</span>
        <span className="text-xs text-muted">
          {isExpanded ? '▼' : '▶'}
        </span>
      </button>
      
      {/* Section states */}
      {isExpanded && (
        <div className="divide-y">
          {items.map((state: TestState) => {
            const isSelected = selectedStateName === state.name
            return (
              <div
                key={state.name}
                data-testid={`state-item-${state.name}`}
              >
                <StateCard
                  state={state}
                  isSelected={isSelected}
                  showChevron={false}
                  onClick={() => onStateClick(state)}
                />
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
